import { useEffect, useState } from "react";

type Variant = "quiz" | "ask" | "generic";

const COPY: Record<Variant, { emoji: string; title: string; hints: string[] }> = {
	quiz: {
		emoji: "💞",
		title: "Bikin kuis buat kalian berdua…",
		hints: [
			"Nyiapin 5 pertanyaan yang lagi-lagi nge-gali personality kamu…",
			"Tenang, ini bukan ngerjain PR kok 😄",
			"Bentar ya, supervisor lagi mantengin biar hasilnya rapi…",
			"Kalau hasilnya kepanjangan, kita pangkas. Janji.",
			"Lagi mikir pertanyaan yang pas buat kalian…",
			"Nyiapin kategori yang lagi hits hari ini…",
		],
	},
	ask: {
		emoji: "🔮",
		title: "Mau ngeramal pasangan kamu nih…",
		hints: [
			"Lagi ngeliat jejak jawabannya dulu…",
			"Prediksi terbaik butuh 2 lapis mikir, makanya agak lama…",
			"Supervisor lagi ngecek biar jawabannya natural…",
			"Jangan ke mana-mana, bentar lagi kelihatan hasilnya…",
			"Sedang ngitung probabilitasnya…",
			"AI-nya lagi serius, jadi mikir agak lama wkwk",
		],
	},
	generic: {
		emoji: "✨",
		title: "Sebentar ya…",
		hints: ["Lagi kerja di belakang layar…", "Hampir selesai…"],
	},
};

export function FunLoader({
	variant = "generic",
	hint,
}: {
	variant?: Variant;
	hint?: string;
}) {
	const copy = COPY[variant];
	const hints = hint ? [hint, ...copy.hints] : copy.hints;
	const [idx, setIdx] = useState(0);

	useEffect(() => {
		const id = setInterval(() => {
			setIdx((i) => (i + 1) % hints.length);
		}, 2800);
		return () => clearInterval(id);
	}, [hints.length]);

	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				justifyContent: "center",
				gap: "1rem",
				padding: "2rem 1rem",
				textAlign: "center",
				minHeight: "240px",
			}}
		>
			<div
				className="fun-loader-emoji"
				style={{ fontSize: "3rem", lineHeight: 1 }}
				aria-hidden
			>
				{copy.emoji}
			</div>
			<h2
				style={{
					margin: 0,
					fontSize: "1.15rem",
					fontWeight: 800,
					color: "var(--color-text)",
				}}
			>
				{copy.title}
			</h2>
		<div
			key={idx}
			className="fun-loader-hint"
			aria-live="polite"
			style={{
				minHeight: "2.5rem",
				maxWidth: "26rem",
				fontSize: "0.92rem",
				lineHeight: 1.5,
				color: "var(--color-text-muted)",
			}}
		>
			{hints[idx]}
			</div>
			<div
				style={{
					display: "flex",
					gap: "0.4rem",
					marginTop: "0.25rem",
				}}
				aria-hidden
			>
				<span className="fun-loader-dot" />
				<span className="fun-loader-dot" style={{ animationDelay: "0.15s" }} />
				<span className="fun-loader-dot" style={{ animationDelay: "0.3s" }} />
			</div>
			<style>{`
				@keyframes funLoaderBounce {
					0%, 80%, 100% { transform: translateY(0); }
					40% { transform: translateY(-6px); }
				}
				.fun-loader-dot {
					width: 0.5rem;
					height: 0.5rem;
					border-radius: 50%;
					background: var(--color-primary);
					display: inline-block;
					animation: funLoaderBounce 1.2s infinite ease-in-out;
				}
				@keyframes funLoaderWobble {
					0%, 100% { transform: rotate(-4deg); }
					50% { transform: rotate(4deg); }
				}
				.fun-loader-emoji {
					display: inline-block;
					animation: funLoaderWobble 2.4s infinite ease-in-out;
				}
				@keyframes funLoaderFade {
					0% { opacity: 0; transform: translateY(4px); }
					15% { opacity: 1; transform: translateY(0); }
					85% { opacity: 1; transform: translateY(0); }
					100% { opacity: 0; transform: translateY(-4px); }
				}
				.fun-loader-hint {
					animation: funLoaderFade 2.8s ease-in-out;
				}
			`}</style>
		</div>
	);
}
